import React from "react";
import PropTypes from "prop-types";
import { Button as MuiButton } from "@material-ui/core";

const CleanButton = React.forwardRef((props, ref) => {
  const { children, className, ...rest } = props;

  return (
    <MuiButton
      {...rest}
      ref={ref}
      className={className}
      style={{
        backgroundColor: "transparent",
        boxShadow: "none",
        textTransform: "none",
        ...rest.style,
      }}
    >
      {children}
    </MuiButton>
  );
});

CleanButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

CleanButton.displayName = "CleanButton";

export default CleanButton;
